import React from "react";
import("./Pricing/RibbonsStyling.scss");
interface RequestToQuoteProps {
  newProduct?: boolean;
  requestAQuoteUrl: string;
}
const RequestToQuote = ({
  newProduct,
  requestAQuoteUrl
}: RequestToQuoteProps) => {
  return <div id="subject" data-testid="request-quote-item" className="side-col ag-product" data-sentry-component="RequestToQuote" data-sentry-source-file="RequestToQuote.tsx">
      {newProduct && <div className="absolute">
          <div className="ribbon ribbon--new relative left-2.5 mt-2.5 xs:left-[-10px] xs:right-2.5 xs:ml-1">
            <span className="ribbon__text">New</span>
          </div>
        </div>}
      <div className="box padded clearfix lg:mb-0 md:mb-5">
        <div>
          <h3 className={`text-xl font-bold mb-2 text-gray-800 ${newProduct ? "mt-[18px]" : ""}`}>
            Contact Us for a Custom Quote
          </h3>
          <p className="text-gray-800 text-sm leading-tight mb-4">
            All items are built made-to-order. Request a custom quote for
            pricing on an item made to your exact specifications.
          </p>
        </div>
        <div className="add-to-cart">
          <a type="submit" className="btn btn-cart btn-large" data-testid="request-a-quote-button" href={requestAQuoteUrl || "/special-orders/"} style={{
          height: "auto"
        }}>
            Request a Quote
          </a>
        </div>
      </div>
    </div>;
};
export default RequestToQuote;